<template>
  <div>
    <div class="thank-you-content align-justify pt40 pl20">
      <div class="container">
        <div class="row">
          <div class="col-md-6 desktop">
            <div class="image-location">
              <img src="/assets/home-location.png" class="image-improvment" width="591" height="289" loading="eager" fetchpriority="high" alt="Thank you for your order!">
            </div>
          </div>
          <div class="col-md-6 block-info-order pl20 pr20">
            <h3 class="confirmation-order">
              {{ $t('Order confirmation') }}
            </h3>
            <p class="info-order mb5" v-if="locationCode !== 'lutsk'"
               v-html="this.$t('Thank you for your order! An email with confirmation and order details has been sent to your email address.')"
            />
            <p class="info-order mb5" v-else>
              {{ $t('Thank you for your order!') }}<br>
              <b>{{ $t('Please, wait for the courier to call.') }}</b><br>
              {{ $t('An email with confirmation and order details has been sent to your email address.') }}
            </p>
            <template>
              <!-- If 1 partner in order -->
              <div class="order-list" v-if="orderIds.length === 1">
                <p class="order-list-item">
                  {{ $t('The Order Number is:') }}
                  <span class="number-order"> {{ orderId }} </span>
                </p>
              </div>
              <!---->

              <!-- If many partners in order -->
              <div class="order-list" v-else-if="orderIds.length > 1">
                <p class="order-list-item" v-for="line in orderLines" :key="line.key">
                  <span class="number-order"> {{ line.number }} </span>
                  <template v-if="line.partner">
                    {{ $t('The Order Number from') }}
                    <b> {{ line.partner }} </b>
                  </template>
                </p>
              </div>
              <!---->
            </template>

            <h4 v-if="OfflineOnly">
              {{ $t('You are offline') }}
            </h4>
            <p v-if="OfflineOnly && !isNotificationSupported">
              {{ $t('To finish the order just come back to our store while online. Your order will be sent to the server as soon as you come back here while online and then confirmed regarding the stock quantities of selected items') }}
            </p>
            <p v-if="OfflineOnly && isNotificationSupported && !isPermissionGranted">
              {{ $t("You can allow us to remind you about the order via push notification after coming back online. You'll only need to click on it to confirm.") }}
            </p>
            <p v-if="OfflineOnly && isNotificationSupported && isPermissionGranted">
              <strong>{{ $t('You will receive Push notification after coming back online. You can confirm the order by clicking on it') }}</strong>
            </p>
            <p>
            </p>
            <div id="thank-you-extensions" />
          </div>
          <div class="col-xs-12 mobile">
            <div class="image-location">
              <img src="/assets/home-location.png" class="image-improvment" width="591" height="289" loading="eager" fetchpriority="high" alt="Thank you for your order!">
            </div>
          </div>
          <div class="col-md-12 thank-you-improvment">
            <div class="flex-desktop">
              <div class="col-md-4 telegram" :style="{'margin-top': isPickup ? '5px' : '30px'}" v-if="telegramLink">
                <div v-if="isPickup"><p>{{ $t('All the information about pickup will be sent in telegram-bot') }}</p></div>
                <a :href="telegramLink">
                  <img src="/assets/qr-code.svg" width="200" height="200" alt="QR code" loading="eager" fetchpriority="high">
                </a>
                <a class="telegram-button col-xs-12 col-md-4" :href="telegramLink">{{ $t('Receive notifications via Telegram bot') }}</a>
              </div>
              <div class="col-md-8">
                <h3 class="center-md center-xs title-improve">
                  {{ $t('What we can improve?') }}
                </h3>
                <p class="mb25 center-md center-xs feedback">
                  {{ $t('Your feedback is important for us. Let us know what we could improve.') }}
                </p>
                <form @submit.prevent="sendFeedback">
                  <div class="textarea-box textarea-wrapper col-xs-12 center-md start-xs">
                    <base-textarea
                      rows="4"
                      cols="10"
                      type="text"
                      class="textarea-custom-success col-md-12"
                      v-model="feedback"
                      @blur="$v.feedback.$touch()"
                      maxlength="10000"
                      data-hj-whitelist
                      :placeholder="this.$t('Your feedback')"
                    />
                  </div>
                  <div class="col-md-4 col-xs-12 button-response">
                    <button type="button" class="text-button-feedback bg-cl-korzyna-green block brdr-none button-full center-lg cl-white h6 mb no-outline
                                    place-order-btn px10 py10 ripple sans-serif weight-400 "
                            @click="sendFeedback"
                    >
                      {{ $t('Submit feedback') }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="back-to-shop col-md-12 col-xs-12 cl-secondary">
              <router-link :to="localizedRoute('/')">{{ $t('Return to shopping') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script async>
import Composite from '@vue-storefront/core/mixins/composite'
import BaseTextarea from 'theme/components/core/blocks/Form/BaseTextarea'
import VueOfflineMixin from 'vue-offline/mixin'
import { EmailForm } from '@vue-storefront/core/modules/mailer/components/EmailForm'
import { isServer } from '@vue-storefront/core/helpers'
import config from 'config'
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators'

const LAST_ORDERS_STORAGE_KEY = 'shop/order/last-placing-orders-data'

/** The confirmation.orders snapshot core's webStorage plugin persists when the order is placed. */
function readLastOrders () {
  if (isServer) return []
  try {
    const stored = JSON.parse(localStorage.getItem(LAST_ORDERS_STORAGE_KEY))
    return Array.isArray(stored) ? stored : []
  } catch (error) {
    return []
  }
}

/** `?additional_orders=` comes as "2332" / "2332,2333" (iPay 3DS return) or as an array. */
function additionalOrderIds (value) {
  return (Array.isArray(value) ? value : String(value || '').split(','))
    .map(id => String(id).trim())
    .filter(id => id !== '')
}

export default {
  name: 'ThankYouPage',
  mixins: [Composite, VueOfflineMixin, EmailForm],
  data () {
    return {
      feedback: '',
      message: true,
      customer: this.$store.state.user.current,
      source: 'order_success',
      orders: [],
      lastPlacedOrders: readLastOrders()
    }
  },
  computed: {
    orderIds () {
      let list = []
      if (this.orderId) {
        list.push(this.orderId)
      }
      let additionalOrders = this.lastOrderConfirmation.orders && this.lastOrderConfirmation.orders.length > 1
        ? this.lastOrderConfirmation.orders.filter(o => o.id !== this.orderId).map(o => o.id)
        : additionalOrderIds(this.$route.query.additional_orders)
      if (additionalOrders.length) {
        list = list.concat(additionalOrders)
      }
      return list
    },
    hasConfirmationOrders () {
      return Array.isArray(this.lastOrderConfirmation.orders) && this.lastOrderConfirmation.orders.length > 0
    },
    // Rows of the "many partners" list. After a full page load (iPay 3DS return) the in-memory
    // confirmation is gone: fall back to the placement snapshot, or to the bare ids.
    orderLines () {
      if (this.hasConfirmationOrders) {
        return this.orderIds
          .filter(item => typeof item !== 'string')
          .map(item => ({ key: item, number: this.partnerOrder(item), partner: this.partnerTitle(item) }))
      }
      const routeOrderId = String(this.$route.params.orderId || '')
      const lines = []
      if (routeOrderId) {
        const order = this.lastPlacedOrders.find(o => String(o.connection_order_id) === routeOrderId)
        lines.push(order
          ? { key: `order-${order.id}`, number: order.connection_order_id, partner: order.partner_name }
          : { key: `route-${routeOrderId}`, number: routeOrderId, partner: null })
      }
      additionalOrderIds(this.$route.query.additional_orders).forEach(id => {
        const order = this.lastPlacedOrders.find(o => String(o.id) === id)
        lines.push(order
          ? { key: `order-${order.id}`, number: order.connection_order_id, partner: order.partner_name }
          : { key: `id-${id}`, number: id, partner: null })
      })
      return lines
    },
    orderId () {
      return this.lastOrderConfirmation.magentoOrderId ? this.lastOrderConfirmation.magentoOrderId : this.$route.params.orderId
    },
    isPickup () {
      return this.lastOrderConfirmation && this.lastOrderConfirmation.orders && this.lastOrderConfirmation.orders.find(order => order.shipping === 'pickup')
    },
    lastOrderConfirmation () {
      return this.$store.state.order.last_order_confirmation ? this.$store.state.order.last_order_confirmation.confirmation : {}
    },
    isNotificationSupported () {
      if (isServer || !('Notification' in window)) return false
      return 'Notification' in window
    },
    isPermissionGranted () {
      if (isServer || !('Notification' in window)) return false
      return Notification.permission === 'granted'
    },
    checkoutPersonalEmailAddress () {
      return this.$store.state.checkout.personalDetails.emailAddress
    },
    checkoutPersonalName () {
      return this.$store.state.checkout.personalDetails.firstName
    },
    ...mapGetters({
      partnerNaming: 'partners/getPartnerByLocationAndByPartnerCode'
    }),
    telegramLink () {
      return config && config.hasOwnProperty('telegram') && config.telegram.hasOwnProperty('link') ? config.telegram.link : false
    },
    locationCode () {
      return this.$route.params.locationCode
    }
  },
  watch: {
    orderIds: {
      immediate: true,
      handler (list) {
        this.orders = list
      }
    }
  },
  mounted () {
    this.resetState();
  },
  methods: {
    partnerTitle (item) {
      let order = this.lastOrderConfirmation.orders.find(order => order.id === item)
      return order ? order.partner_name : null
    },
    partnerOrder (item) {
      let order = this.lastOrderConfirmation.orders.find(order => order.id === item)
      return order ? order.connection_order_id : item
    },
    sendFeedback () {
      if (this.$v.$invalid) {
        this.showErrors('Fill in the comment field')
      } else {
        this.addReview({
          customer_id: this.customer ? this.customer.id : 0,
          customer_name: this.checkoutPersonalName,
          customer_email: this.checkoutPersonalEmailAddress,
          location_code: this.locationCode,
          source: this.source,
          text: this.feedback
        }).then(sent => {
          if (sent) this.resetForm();
        })
      }
    },
    resetForm () {
      this.feedback = '';
      this.$v.$reset();
    },
    showErrors (messageError) {
      this.$v.feedback.$touch();
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t(messageError),
        action1: {label: this.$t('OK')}
      })
    },
    onFailure (message) {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message,
        action1: { label: this.$t('OK') }
      })
    },
    ...mapActions({
      resetState: 'partners/resetCurrentPartner',
      addReview: 'review/add',
      createPayment: 'ipay-payment-user/createPayment'
    })
  },
  destroyed () {
    this.$store.dispatch('checkout/setThankYouPage', false)
    if (!!this.customer && !this.customer.hasOwnProperty('deleted_addresses')) {
      this.customer.deleted_addresses = []
    }
    this.$store.dispatch('user/me')
  },
  components: {
    BaseTextarea
  },
  validations: {
    feedback: {
      required
    }
  }
}
</script>
<style lang="scss">
  .textarea-custom-success {
    label{
      left: 15px;
      top: 20px;
    }
    textarea {
      height: 60px;
      border-radius: 5px;
      border: solid 1px #bdbdbd;
      background-color: #ffffff;
      resize: none;
      font-family: 'TTNorms Regular', sans-serif;
      padding: 15px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.09px;
      &:focus {
        ~ {
          label {
            top: 10px;
            font-size: 14px;
          }
        }
      }
      &:not(.empty) {
        ~ {
          label {
            top: 10px;
            font-size: 14px;
          }
        }
      }
      &.error{
        border: solid 1px #bdbdbd;
      }
    }
  }
</style>
<style scoped lang="scss">
  .thank-you-content {
    padding-left: 0;

    p {
      line-height: 25px
    }

    @media (min-width: 64em) {
      h4 {
        font-size: 24px;
      }
    }
  }
  .thank-you-improvment {
    padding: 0 20px 15px;

    @media (min-width: 64em) {
      padding: 0 40px 10px;
    }
  }
  .confirmation-order{
    font-size: 34px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.28px;
    margin-bottom: 0;
    @media (max-width: 600px) {
      font-size: 24px;
      letter-spacing: 0.2px;
      margin-top: 0;
    }
  }
  .info-order{
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.11px;
    @media (max-width: 1023px) {
      margin-top: 5px;
    }
  }
  .title-improve{
    font-size: 21px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.09px;
    margin-bottom: 0;
  }
  .feedback{
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.07px;
    margin-top: 5px;
    @media (max-width: 600px) {
      font-size: 14px;
    }
  }

  .button-response{
    margin: 0 auto;
    margin-top: 20px;
  }
  .text-button-feedback{
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.05px;
    padding: 13px;
  }
  .checkbox-text{
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.06px;
  }
  .desktop{
    @media (max-width: 1023px) {
      display: none;
    }
  }
  .mobile{
    display: none;
    @media (max-width: 1023px) {
      display: block;
      text-align: center;
    }
  }
  .image-improvment{
    width: 100%;
    object-fit: contain;
    @media (max-width: 1023px) {
      width: auto;
    }
    @media (max-width: 676px) {
      width: 100%;
    }
  }
  .block-info-order.col-md-6{
    @media (max-width: 1023px) {
      flex-basis: 100%;
      max-width: 100%;
      margin: 0 auto;
      text-align: center;
    }
  }
  .checkbox-message{
    justify-content: flex-start;
    text-align: start;
    @media (max-width: 1023px) {
      flex-basis: 45%;
      max-width: 45%;
      margin: 0 auto;
      justify-content: center;
      text-align: center;
    }
    @media (max-width: 768px) {
      flex-basis: 62%;
      max-width: 62%;
    }
    @media (max-width: 516px) {
      flex-basis: 180%;
      max-width: 80%;
    }
    @media (max-width: 400px) {
      flex-basis: 100%;
      max-width: 100%;
    }
  }
  .number-order{
    font-weight: 500;
    color: #11bb2e;
    margin-left: 10px;
  }
  .back-to-shop{
    text-align: center;
    margin-top: 30px;
  }

  .order-list {
    margin-top: 20px;

    &-item {
      margin: 0;
    }
  }
  .telegram {
    text-align: center;
    align-self: center;
    &-button {
      margin: 0 auto;
      background: #11bb2e;
      padding: 10px;
      font-size: 15px;
      font-weight: 400;
      font-family: 'TTNorms Regular', sans-serif;
      min-width: 250px;
      border-radius: 10px;
      color: #fff;
    }
    a {
      display: block;
    }
  }
  .flex-desktop {
    display: flex;
    @media (max-width: 768px) {
      display: block;
    }
  }
</style>
